import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const MarketoIcon = ({ width = "24", height = "24" }: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9999 2V22L20.1162 17.9204V4.77575L14.9999 2Z"
          fill="#5C4C9F"
        />
        <path
          d="M12.6433 17.6278L8.51932 19.4263V3.73633L12.6433 4.96355V17.6278Z"
          fill="#5C4C9F"
        />
        <path
          d="M2.99997 17.1373L6.12937 16.3175L6.13175 6.33568L3.00235 5.8396L2.99997 17.1373Z"
          fill="#5C4C9F"
        />
      </svg>
    </IconWrapper>
  );
};
